module.exports = __webpack_public_path__ + "static/media/RO.2e3d0e37.svg";